import store from '../store';
import { setMenuGroups } from '../actions';
import MenuObject, { addDisplayPrices, getMenuItems } from './menu-object';
import util from '../util';
import * as actions from '../actions';
import menuObject from "./menu-object";
import {filterMenuItemByLocation} from "../service/posService";

const SOURCE_MHM = "mhm";

export function syncInGroup($object, groups) {
  if ($object.length > 1) {
    $object = $object.eq(0);
  }
  let groupId = $object.attr("data-id");
  let groupName = getMenuGroupName($object);

  let group = null;
  if (groupId) {
    group = groups.find(it => it.id === groupId);
  }
  if (!group) {
    group = groups.find(it => it.name === groupName 
                        || it.name === `Untitled (${groupName})`
                        || it.name.includes(groupName) || groupName.includes(it.name));
  }

  if (!!group) {
    if (group.source === 'square' || group.source === 'toast' || group.source === 'treez' || group.source === 'popmenu') {
      return;
    }

    if (!$object.attr('data-id')) {
      $object.attr("data-id", group.id);
    }

    const updates = getMenuItems($object);
    group.items = [];
    updates.forEach(update => {
      group.items.push({
        name: update.name,
        description: update.description,
        prices: update.prices,
        extras: update.extras,
        modifiers: update.modifiers,
        bin: update.bin,
        binHeader: update.binHeader,
        icons: update.icons,
        id: update.id,
        parentId: update.parentId,
        source: update.source
      });
    });
    group.name = groupName;
    group.isInferredTitle = isInferredTitle($object);
  } else {
    groupId = util.UUID.get();
    $object.attr("data-id", groupId);

    const items = getMenuItems($object);
    items.forEach(it => {
      it.parentId = groupId;
      it.source = SOURCE_MHM;
    });

    groups.push({
      id: groupId,
      name: groupName,
      items,
      source: SOURCE_MHM,
      isInferredTitle: isInferredTitle($object)
    })
  }

  store.dispatch(setMenuGroups([...groups]));
}

export function getMenuGroupName($object) {
  let name = $object.find(".mo-name").text().trim();
  if (!name) {
    const itemName = $object.find(".item:first").find(".name").text().trim();
    const trimmed = itemName.length > 30 ? itemName.slice(0, 30) + "..." : itemName;
    name += `${trimmed}`;
  }
  return name;
}

function isInferredTitle($object) {
  let name = $object.find(".mo-name").text().trim();
  if (!name) return true;
  return false;
}

function getLocationId(source) {
  if (source.toLowerCase() !== 'square' || !window.data.squareLocations || !window.data.design.locationId || !window.data.locations) return null;
  const location = window.data.locations.find(it => it.internalId === window.data.design.locationId);
  if (!location) return null;
  return window.data.squareLocations.find(it => it.dbId === location.squareLocationId)?.id;
}

export function updateMenuGroupContent($mo, group, source) {
  const hideTrailingZeroes = $mo.attr('data-hide-trailing-zeroes') === "true" || false;
  const locationId = getLocationId(source);
  // group.items = group.items.filter(it => filterMenuItemByLocation(it, locationId));
  group.items = [...addDisplayPrices(group.items, hideTrailingZeroes, locationId)];

  MenuObject.updateContent($mo, sortItems(group.items), true, false, true, true, undefined, group.name, true, true, group);
  $mo.attr("data-source", source.toLowerCase());
  $mo.attr("data-id", group.id);
  $mo.attr("data-menuid", group.menuId);

  util.nextTick(() => {
    menuObject.checkPosDataUsage();
  })
}

function sortItems(items) {
  return items.sort((a, b) => a.sequence - b.sequence);
}

export function getMenuGroupsFromDesign() {
  const groups = [];

  $(".menu-object").each(function() {
    const $object = $(this);
    groups.push({
      id: util.UUID.get(),
      name: getMenuGroupName($object),
      items: getMenuItems($object),
      isInferredTitle: isInferredTitle($object)
    })
  });

  store.dispatch(actions.setMenuGroups(groups));
}
